// @flow
import type { OperationResult } from 'types/app';
import { Endpoints } from 'UI/constants/endpoints';

import { sendRequest } from './utils';

export const searchByPhoneNumber = async (phoneNumber: string): Promise<OperationResult> => {
  const queryParams = new URLSearchParams({
    limit: 3,
    partialPhone: phoneNumber
  });

  const result = await sendRequest(
    `${Endpoints.Names}?${queryParams.toString()}`,
    'get',
    null,
    null,
    null,
    2
  );

  return result;
};
